import Image from 'next/image';
import { clsx } from 'clsx';

import { Avatar, Flag, Typography } from '@monoimin/atoms';
import { SbRichTextLite } from '@monoimin/molecules/richtext/SbRichTextLite';

import { ScrollGradientContainer } from './ScrollGradientContainer';

import type { ReviewCardProps } from '@monoimin/sb-types';

export function ReviewCard({
  withBackground,
  reviewText,
  customer,
  className,
  textClassName,
  textMaxHeight,
  textOverflow,
  onClick,
}: ReviewCardProps) {
  return (
    <div
      data-testid='review-card'
      data-clickable='true'
      onClick={onClick}
      className={clsx(
        'review-card relative border border-line p-6 rounded-t-4xl overflow-hidden rounded-br-4xl text-left flex flex-col',
        {
          'bg-blueGrey': withBackground,
          'bg-white': !withBackground,
        },
        className
      )}
    >
      {customer && !withBackground && (
        <div className='relative flex justify-between mb-10'>
          <div>
            <Typography className='body font-bold'>{customer?.name}</Typography>
            <Typography className='caption'>{customer?.description}</Typography>
          </div>
          <div className='relative flex flex-col shrink-0 h-fit'>
            <Avatar src={customer?.image} alt={customer?.name} size={60} />
            {typeof customer?.country === 'string' && (
              <Flag
                countryCode={customer?.country}
                className='absolute -bottom-2 right-0'
              />
            )}
          </div>
        </div>
      )}

      {withBackground && (
        <Flag
          countryCode={customer?.country as string}
          size='medium'
          className='mt-2 mb-6'
        />
      )}
      <ScrollGradientContainer
        maxHeight={textMaxHeight}
        className={textClassName}
        overflow={textOverflow}
      >
        <SbRichTextLite
          blok={reviewText}
          className='space-y-4'
          classNames={{
            paragraph: withBackground ? 'font-bold subheading' : 'body',
          }}
        />
      </ScrollGradientContainer>
      {withBackground && (
        <>
          <div className='w-[calc(100%-170px)]'>
            <Typography className='body font-bold'>{customer?.name}</Typography>
            <Typography className='caption'>{customer?.description}</Typography>
          </div>
          <Image
            quality='65'
            src={customer?.image ?? ''}
            alt={customer?.name ?? ''}
            width={166}
            height={188}
            className='object-contain absolute bottom-0 right-0 pointer-events-none'
          />
        </>
      )}
    </div>
  );
}

export default ReviewCard;
